import { Alert, Box, Button, Fade, Modal, Snackbar, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { RequestError, useApi } from "../../services";
import logo from "../../assets/hidrobrLogo.png";

interface LoginModalProps {
  open: boolean;
  onClose?: () => void;
  onLogin?: () => void;
}
export const HBRLoginModal: React.FC<LoginModalProps> = ({ open, onClose, onLogin }) => {

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Box sx={{
          position: "absolute" as const,
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          borderRadius: "8px",
          boxShadow: 24,
          p: 4,
        }}>
          <HBRLoginItem onLogin={onLogin} />
        </Box>
      </Fade>
    </Modal>
  );
};

interface HBRLoginItemInterface {
  onLogin?: () => void;
}
export const HBRLoginItem: React.FC<HBRLoginItemInterface> = ({ onLogin }) => {
  const api = useApi();

  const [error, setError] = useState<RequestError>();
  const [email, setEmail] = useState<string>('');
  const [passw, setPassw] = useState<string>('');

  const handleLogin = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!email || !passw) return;

    api.user.login(email, passw).then((login) => {
      if ("error" in login) {
        setError({
          error: "Login Error",
          message: "Erro ao realizar o login",
        });
        return;
      }
      localStorage.setItem("authToken", login.token);
      if (onLogin) onLogin();
    });
  };

  const handleCloseAlert = () => {
    setError(undefined);
  };

  return (<>
    {error &&
      <Snackbar
        open={error !== null}
        autoHideDuration={4500}
        onClose={handleCloseAlert}
        message="Note archived"
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert onClose={handleCloseAlert} severity="error" sx={{ width: "100%" }}>
          {error.error + ":" + error.message}
        </Alert>
      </Snackbar>
    }
    <Box display="flex" alignItems="center" marginBottom={2}>
      <Box
        component="img"
        src={logo}
        alt="Logo da Empresa"
        sx={{ height: 50, marginRight: 2 }}
      />
      <Typography
        fontSize={26}
        fontWeight={"bold"}
      >
        Login
      </Typography>
    </Box>
    <Box component="form" onSubmit={handleLogin}>
      <TextField
        margin="normal"
        required
        fullWidth
        id="email"
        label="Email"
        name="email"
        autoComplete="email"
        autoFocus
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <TextField
        margin="normal"
        required
        fullWidth
        name="password"
        label="Senha"
        type="password"
        id="password"
        autoComplete="current-password"
        value={passw}
        onChange={(e) => setPassw(e.target.value)}
      />
      <Button
        type="submit"
        fullWidth
        variant="contained"
        sx={{ mt: 3, mb: 2 }}
      >
        Entrar
      </Button>
    </Box>
  </>
  );
};
